// Liens vers CleanyApp (https://app.cleany.fr), qui reprend la saisie des
// préaffectations à la place de l'app Bubble app-manager (plan 070b, lot P1).
//
// Le paramètre `siteId` de la page Workforce Management ouvre le drawer du
// site. Il attend l'id du compte care, le même que celui du backoffice : le
// drawer de CleanyApp renvoie lui-même vers bo.cleany.fr/#/account/<siteId>/show.

export const CLEANY_APP_URL = 'https://app.cleany.fr';

export const WORKFORCE_MANAGEMENT_URL = `${CLEANY_APP_URL}/workforce-management`;

export const PREAFFECTATIONS_URL = `${CLEANY_APP_URL}/preaffectations`;

// Sans id de compte, renvoie la heatmap : on y choisit le site.
export const getSitePlanningUrl = (accountId) => {
  if (!accountId) {
    return WORKFORCE_MANAGEMENT_URL;
  }
  return `${WORKFORCE_MANAGEMENT_URL}?siteId=${encodeURIComponent(accountId)}`;
};

// Site principal d'un cleaner : celui de l'affectation permanente active qui
// compte le plus d'heures par semaine. Les affectations arrivent triées par
// `duration_per_week` décroissant ; en tri décroissant, Postgres place les
// durées nulles en tête, d'où la recherche de la première durée renseignée.
// Renvoie { id, name }, ou null si aucun site n'est connu ou si la réponse
// n'est pas une liste (corps d'erreur).
export const pickMainSite = (affectations) => {
  if (!Array.isArray(affectations)) {
    return null;
  }
  const withSite = affectations.filter((affectation) => {
    return !!(affectation && affectation.account_id);
  });
  const main =
    withSite.find((affectation) => {
      return !!affectation.duration_per_week;
    }) || withSite[0];
  if (!main) {
    return null;
  }
  return { id: main.account_id, name: main.account_name || null };
};
